// IE 2026 11 04 / ODOO-5800 (проба p269: Esc закрывает меню, а не виджет; лёгкий запрос сводки)
// Проба p269 (dev02, fe-2026-11-04-8): меню кнопки «Plan approval» шапки Баланса (AttrMenu → wj-menu, openOnHover) открыто наведением, Escape закрыл ВЕСЬ виджет.
// Причина: App.handleKeydown (document, capture) в ветке Escape проверял форму ячейки, чипсы, панель виджета, поиск — но не открытый список wj-menu; фокус при открытии
// наведением остаётся вне меню, собственный Escape wijmo (keydown хоста меню) не срабатывает, и событие уходило в store.runActionForHotKey(activeWIDGET, 'Esc') →
// скрытое действие Widget.vue {hotkey:'Esc', command:'onCloseWindow__Click'}. MenuPanel (≡ таблицы / виджета / полей) свой Escape ловит раньше (window, capture) — не затронут.
// Правило: открыт хотя бы один список wj-menu (любое AttrMenu шапки грида / виджета / формы ячейки, в т.ч. открытое наведением) — Escape закрывает только его, событие гасится
// и до закрытия виджета (и формы ячейки под меню) не доходит; Alt+Esc — как раньше (своя ветка App). Следующий Escape — обычным путём.
// Выключатель fe.ux.escClosesOpenMenu (дефолт ВКЛ; false — как до правки). Без Vue / DOM — юнит-тест tests/unit/escOpenMenu.test.mjs
export const ESC_OPEN_MENU_FLAG = 'fe.ux.escClosesOpenMenu'
export const MENU_HOST_SELECTOR = '.wj-menu'

export function escOpenMenu_on(setting) {   // нет читателя / ошибка — ВКЛ
    try { return typeof setting === 'function' ? setting(ESC_OPEN_MENU_FLAG, true) !== false : true } catch (e) { return true }
}

// открытые меню: hosts — элементы .wj-menu, getControl — wijmo Control.getControl; открыто — isDroppedDown контрола
export function escOpenMenu_find(hosts, getControl) {
    const out = []
    if (typeof getControl !== 'function') return out
    for (const h of hosts || []) {
        let c = null
        try { c = getControl(h) } catch (e) { c = null }
        try { if (c && c.isDroppedDown === true && !out.includes(c)) out.push(c) } catch (e) { /* контрол разрушен */ }
    }
    return out
}

// решение по клавише: 'menu' — закрыть открытые меню и погасить событие; 'pass' — дальше обычным путём
export function escOpenMenu_decide({ flagOn = true, key = '', altKey = false, open = 0 } = {}) {
    return (flagOn && key === 'Escape' && !altKey && open > 0) ? 'menu' : 'pass'
}

// закрыть меню; число закрытых
export function escOpenMenu_close(menus) {
    let n = 0
    for (const m of menus || []) { try { m.isDroppedDown = false; n++ } catch (e) { /* контрол разрушен */ } }
    return n
}

// всё вместе для обработчика клавиш: true — Escape съеден открытым меню (событие погашено)
export function escOpenMenu_handle(event, doc, getControl, setting) {
    if (!event || event.key !== 'Escape' || event.altKey) return false
    if (!escOpenMenu_on(setting)) return false
    let hosts = []
    try { hosts = doc && typeof doc.querySelectorAll === 'function' ? doc.querySelectorAll(MENU_HOST_SELECTOR) : [] } catch (e) { hosts = [] }
    const open = escOpenMenu_find(hosts, getControl)
    if (escOpenMenu_decide({ flagOn: true, key: event.key, altKey: event.altKey, open: open.length }) !== 'menu') return false
    escOpenMenu_close(open)
    try { event.preventDefault(); event.stopPropagation() } catch (e) { /* не событие */ }
    try { if (typeof window !== 'undefined') window.__escOpenMenuClosed = (window.__escOpenMenuClosed || 0) + 1 } catch (e) { /* без window */ }
    return true
}
